import { useState } from "react";

const InterviewRejectForm = ({ onSubmit, onCancel, loading = false }) => {
  const [formData, setFormData] = useState({
    rejection_reason: "",
    decision_notes: "",
  });

  const [errors, setErrors] = useState({});

  const rejectionReasons = [
    "Technical",
    "Communication",
    "Experience",
    "Cultural Fit",
    "Other",
  ];

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error for this field
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const validate = () => {
    const newErrors = {};

    // Validate rejection_reason
    if (!formData.rejection_reason) {
      newErrors.rejection_reason = "Rejection reason is required";
    }

    // Validate decision_notes
    if (!formData.decision_notes.trim()) {
      newErrors.decision_notes = "Decision notes are required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    const submissionData = {
      status: "complete",
      decision: "Rejected",
      rejection_reason: formData.rejection_reason,
      decision_notes: formData.decision_notes.trim(),
    };

    onSubmit(submissionData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Rejection Reason */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Rejection Reason <span className="text-red-500">*</span>
        </label>
        <select
          value={formData.rejection_reason}
          onChange={(e) => handleChange("rejection_reason", e.target.value)}
          className={`w-full px-3 py-2 border rounded-md dark:bg-gray-800 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            errors.rejection_reason ? "border-red-500" : "border-gray-300"
          }`}
        >
          <option value="">Select rejection reason</option>
          {rejectionReasons.map((reason) => (
            <option key={reason} value={reason}>
              {reason}
            </option>
          ))}
        </select>
        {errors.rejection_reason && (
          <p className="mt-1 text-sm text-red-500">{errors.rejection_reason}</p>
        )}
      </div>

      {/* Decision Notes */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Decision Notes <span className="text-red-500">*</span>
        </label>
        <textarea
          value={formData.decision_notes}
          onChange={(e) => handleChange("decision_notes", e.target.value)}
          rows={4}
          className={`w-full px-3 py-2 border rounded-md dark:bg-gray-800 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            errors.decision_notes ? "border-red-500" : "border-gray-300"
          }`}
          placeholder="Candidate lacks required technical skills for the position. Unable to solve basic programming problems during the interview."
        />
        {errors.decision_notes && (
          <p className="mt-1 text-sm text-red-500">{errors.decision_notes}</p>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Submitting..." : "Submit Rejection"}
        </button>
      </div>
    </form>
  );
};

export default InterviewRejectForm;

